import { Cin7OmniBomImportStrategy } from "@redotech/redo-model/cin7-omni-integration";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const updateCin7OmniIntegration = {
  name: "updateCin7OmniIntegration" as const,
  input: z.object({
    integrationId: zExt.objectId(),
    oms: z
      .object({
        bomImportStrategy: createEnum(Cin7OmniBomImportStrategy).optional(),
      })
      .optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
